import clsx from 'clsx'
import { ReactNode, useRef, useState } from 'react'
import { SwiperRef } from 'swiper/react'

import { Pagination } from '../Pagination/Pagination'
import { SwiperSlider } from '../SwiperSlider/SwiperSlider'

import cl from './Slider.module.scss'

type SliderProps = {
	className?: string
	slides: ReactNode[]
	autoplay?: boolean
	isNavigationHidden?: boolean
}

export const Slider = (props: SliderProps) => {
	const { className, slides = [], autoplay, isNavigationHidden } = props

	const [activeIndex, setActiveIndex] = useState(0)

	const swiperRef = useRef<SwiperRef>(null)

	const onPaginationClick = (index: number) => {
		swiperRef.current?.swiper.slideTo(index)
	}

	return (
		<div className={clsx(cl.root, className)}>
			<SwiperSlider
				slides={slides}
				onSlideChange={setActiveIndex}
				ref={swiperRef}
				autoplay={autoplay}
				isNavigationHidden={isNavigationHidden}
			/>
			<Pagination count={slides.length} activeIndex={activeIndex} onClick={onPaginationClick} />
		</div>
	)
}
